import React from 'react';
import '../Assets/css/Grupo.css'; // Ensure the CSS path matches your project structure
export const GrupoPluss = () => {
    return (
        <div className="group-pluss">
            <div className="group-container">
                <div className="group-text">
                    <h1>Somos Grupo Pluss Chile</h1>

                    <p>Pluss Minería es una empresa de transporte de personal, nuestro norte es prestar
                        un servicio de calidad y cubrir todas las necesidades del cliente, dando la mejor
                        experiencia de viaje, y seguridad. Esto lo logramos a través de los más altos
                        estándares de calidad, comodidad y seguridad, respaldados por los sistemas
                        tecnológicos más modernos que tenemos disponibles en nuestra flota.</p>

                    <p>Perteneciente al Grupo Pluss Chile, que desde hace ocho años ha sido pionera
                        y ha marcado un hito como referentes en el mercado a nivel nacional. Irrumpimos
                        en el transporte interurbano de pasajeros y en el transporte privado en la gran
                        minería con una nueva experiencia de viaje, donde la comodidad, seguridad,
                        entretenimiento y servicio abordo se han convertido es nuestros pilares.</p>
                </div>
            </div>
        </div>
    )
}